import React from 'react';
import { Styles } from './Styles/MerchantListHeaderStyles';

const MerchantListHeader = ({ role, canCreateStore, onCreateStore }) => {
  return (
    <Styles>
      <h3>{role < 200 ? 'Customers' : 'My Store'}</h3>
      {canCreateStore && typeof onCreateStore === 'function' ? (
        <button type="button" className="create-merchant-btn" onClick={onCreateStore}>
          <i className="tim-icons icon-simple-add" style={{ marginRight: 10 }} />
          Add Customer
        </button>
      ) : null}
    </Styles>
  );
};

export default MerchantListHeader;
